// Copyright (c) Ping. All rights reserved.

import type { LeaderboardColumnKind, LeaderboardSortDirection } from './types';

export const leaderboardStrings = {
  screenTitle: 'Leaderboard',
  emptyTitle: 'No leaderboard yet',
  emptyBody: 'Pick a template or build your own to start tracking results.',
  errorTitle: "Couldn't load leaderboard",
  errorRetry: 'Try again',
  templatePickerTitle: 'Choose a template',
  templatePickerCta: 'Use template',
  customBoardCta: 'Start blank',
  addEntryCta: 'Add entry',
  addColumnCta: 'Add column',
  addEntryTitle: 'Add entry',
  addColumnTitle: 'Add column',
  columnNameLabel: 'Column name',
  columnNamePlaceholder: 'Name',
  columnKindLabel: 'Column type',
  saveCta: 'Save',
  cancelCta: 'Cancel',
  doneCta: 'Done',
  columnKind: (kind: LeaderboardColumnKind): string => {
    switch (kind) {
      case 'text':
        return 'Text';
      case 'number':
        return 'Number';
      case 'date':
        return 'Date';
      case 'member':
        return 'Member';
      case 'status':
        return 'Status';
    }
  },
  sortDirection: (direction: LeaderboardSortDirection): string => {
    switch (direction) {
      case 'ascending':
        return 'Ascending';
      case 'descending':
        return 'Descending';
    }
  },
  optionMenu: {
    rename: 'Rename board',
    duplicate: 'Duplicate board',
    delete: 'Delete board',
    removeColumn: 'Remove column',
  },
  emptyCellPlaceholder: '—',
} as const;

export type LeaderboardStrings = typeof leaderboardStrings;
